module.exports = __webpack_public_path__ + "img/company.94c7c84b.png";